import { UserTrackingDetails } from "components/UserTracking/UserTrackingDetails.old";
import UserTrackingSummary from "components/UserTracking/UserTrackingSummary.js";
import React, { useState } from "react";

export function Reports(props) {
  const [user, setUser] = useState(null);

  if (user !== null) return <UserTrackingDetails userId={user} />;

  return <UserTrackingSummary setUser={setUser} />;
}
